import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {

}
const qsAll = {
  qtyChanges: 'data-cart-qty-change',
  tabButtons: 'data-cart-tab',
  tabContents: 'data-cart-tab-content',
}

export const setupCart = () => {
  cacheDom(dom, qs, qsAll)
  dom.qtyChanges.forEach(qtyChange => {
    qtyChange.addEventListener('click', () => {
      qtyChange.disabled = true
      window.changeLineItem((cart) => {
        if(qtyChange.getAttribute('data-cart-qty-change') == 'gwp') Cookies.set('gwp_remove', true)
        if(cart.items.filter(item => item.properties['Gift']).length > 0) {
          setTimeout(() => {
            location.reload()
          }, 700)
        } else {
          location.reload()
        }
      }, {
        quantity: parseInt(qtyChange.dataset.quantity),
        id: qtyChange.dataset.itemKey,
      })
    })
  })
  dom.tabButtons.forEach(tabButton => {
    tabButton.addEventListener('click', () => {
      const id = tabButton.dataset.cartTab
      dom.tabButtons.forEach(tab => {
        tab.classList.toggle('opacity-50', tab != tabButton)
        tab.classList.toggle('hover:opacity-100', tab != tabButton)
      })
      dom.tabContents.forEach(tabContent => tabContent.classList.toggle('hidden', tabContent.id != id))
    })
  })
}